import { PhoneCall, Mail } from "lucide-react";
import { PHONE, PHONE_HREF, EMAIL, EMAIL_HREF } from "@/data";

const StickyBar = () => (
  <div className="fixed bottom-0 left-0 right-0 z-40 border-t border-[#1C2027] bg-[#0A0C10]/95 backdrop-blur-xl" data-testid="sticky-contact-bar">
    <div className="grid grid-cols-2">
      <a
        href={PHONE_HREF}
        data-testid="strip-phone-link"
        className="group flex items-center justify-center gap-2 border-r border-[#1C2027] px-2 py-3.5 transition-colors duration-300 hover:bg-[#F5A800]"
      >
        <PhoneCall className="h-4 w-4 text-[#F5A800] transition-colors duration-300 group-hover:text-[#0A0C10]" />
        <span className="text-xs font-bold uppercase tracking-[0.12em] text-[#F5A800] transition-colors duration-300 group-hover:text-[#0A0C10] sm:text-sm">{PHONE}</span>
      </a>
      <a
        href={EMAIL_HREF}
        data-testid="strip-email-link"
        className="group flex items-center justify-center gap-2 px-2 py-3.5 transition-colors duration-300 hover:bg-[#F5A800]"
      >
        <Mail className="h-4 w-4 shrink-0 text-[#F5A800] transition-colors duration-300 group-hover:text-[#0A0C10]" />
        <span className="truncate text-xs font-bold uppercase tracking-[0.12em] text-[#F5A800] transition-colors duration-300 group-hover:text-[#0A0C10] sm:text-sm">{EMAIL}</span>
      </a>
    </div>
  </div>
);

export default StickyBar;
